<div class="filter-toolbar" [formGroup]="filterForm">
    <ng-container *ngFor="let col of searchableColumns; trackBy: colKey">
        <input
            *ngIf="col.searchable === 'text'"
            type="text"
            class="form-control input-sm filter-control"
            [formControlName]="col.key"
            [placeholder]="col.name"
        />
        <input
            *ngIf="col.searchable === 'daterange'"
            type="text"
            class="form-control input-sm filter-control"
            [formControlName]="col.key"
            [placeholder]="col.name"
            bsDaterangepicker
            container="body"
            triggers="click"
        />
        <ng-select
            *ngIf="col.searchable === 'selection'"
            class="filter-control"
            [formControlName]="col.key"
            [items]="col.searchOptions"
            bindLabel="name"
            bindValue="value"
            [groupBy]="col.groupBy"
            [compareWith]="compareSearchOption"
            [placeholder]="col.name"
            [clearable]="col.clearableSearch !== false"
            appendTo="body"
        ></ng-select>
    </ng-container>
    <div class="fill"></div>
    <button
        type="button"
        class="btn btn-tertiary"
        [popover]="columnPicker"
        [outsideClick]="true"
        placement="bottom"
        container="body"
        tooltip="Show/hide columns"
    >
        <span class="fal fa-ellipsis-h"></span>
    </button>
</div>

<ng-template #columnPicker>
    <div class="column-picker">
        <label *ngFor="let col of selectableColumns" class="checkbox">
            <input
                type="checkbox"
                [checked]="isColumnVisible(col.key)"
                (change)="toggleColumn(col.key)"
            />
            {{ col.name }}
        </label>
    </div>
</ng-template>

<div class="flight-log-datatable" #scrollRegion>
    <ngx-datatable
        class="bootstrap"
        [rows]="rows"
        [columnMode]="ColumnMode.force"
        [headerHeight]="headerHeight"
        [footerHeight]="0"
        [rowHeight]="rowHeight"
        [rowIdentity]="rowIdentity"
        [externalPaging]="true"
        [externalSorting]="true"
        [count]="tableConfig.totalItems"
        [limit]="tableConfig.limit"
        [offset]="tableConfig.currentPage"
        [sorts]="datatableSorts"
        [selectionType]="SelectionType.checkbox"
        [selected]="selected"
        [rowClass]="rowClass"
        [messages]="{ emptyMessage: 'No flight logs found' }"
        (select)="onSelect($event)"
        (sort)="onSort($event)"
        (reorder)="onReorder($event)"
    >
        <!-- Fixed checkbox column: not draggable, not sortable -->
        <ngx-datatable-column
            [width]="34"
            [sortable]="false"
            [draggable]="false"
            [resizeable]="false"
            [canAutoResize]="false"
            [checkboxable]="true"
            [headerCheckboxable]="true"
        ></ngx-datatable-column>

        <ngx-datatable-column
            *ngFor="let col of displayColumns; trackBy: colKey"
            [name]="col.name"
            [prop]="col.key"
            [sortable]="col.sortable !== false"
            [draggable]="true"
        >
            <ng-template ngx-datatable-cell-template let-row="row">
                <ng-container
                    *ngIf="templateFor(col.key) as tpl; else plainValue"
                >
                    <ng-container
                        *ngTemplateOutlet="
                            tpl;
                            context: { row: row.data, column: col }
                        "
                    ></ng-container>
                </ng-container>
                <ng-template #plainValue>{{ row[col.key] }}</ng-template>
            </ng-template>
        </ngx-datatable-column>

        <!-- Fixed trailing actions column -->
        <ngx-datatable-column
            *ngIf="rowActionsTemplate != null"
            name=""
            [sortable]="false"
            [draggable]="false"
            [resizeable]="false"
            [canAutoResize]="false"
            [width]="actionsWidth"
        >
            <ng-template ngx-datatable-cell-template let-row="row">
                <ng-container
                    *ngTemplateOutlet="
                        rowActionsTemplate.tpl;
                        context: { row: row.data }
                    "
                ></ng-container>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>

<div class="table-footer">
    <ng-container *ngIf="tableConfig.bulkActions?.length > 0">
        <button
            *ngFor="let action of tableConfig.bulkActions"
            type="button"
            class="btn btn-sm btn-default"
            [disabled]="selected.length === 0"
            (click)="action.action(selectedRows)"
        >
            {{ action.name
            }}<ng-container *ngIf="selected.length > 0">
                ({{ selected.length }})</ng-container
            >
        </button>
    </ng-container>
    <div class="fill"></div>
    <pagination
        [totalItems]="tableConfig.totalItems ?? 0"
        [itemsPerPage]="tableConfig.limit"
        [maxSize]="5"
        [boundaryLinks]="true"
        [ngModel]="(tableConfig.currentPage ?? 0) + 1"
        (pageChanged)="onFooterPageChanged($event.page)"
    ></pagination>
</div>
